import {Select} from 'antd';
import React from 'react';
import {countryCodes} from '@/constants';

export interface IPhoneCountrySelectorProps {
  onChange: () => void;
}

const PhoneCountrySelector = ({onChange}: IPhoneCountrySelectorProps) => (
  <Select
    // style={{ width: '200px' }}
    onChange={onChange}
    defaultValue='+966'
    getPopupContainer={trigger => trigger.parentNode}
    options={countryCodes.map((code: { dial_code: string }) => ({
      label: code.dial_code,
      value: code.dial_code,
    }))}
  />
);

export default PhoneCountrySelector;
